import axios from '@/lib/axios';
import type {
  ColdStorageUnit,
  HumidityHistoryResponse,
  NotificationSettingsPayload,
  TemperatureHistoryResponse,
} from '@/types/frigo';

export const getTunnels = async (): Promise<ColdStorageUnit[]> => {
  const req = await axios.get('/tunnels/');
  return req.data.results;
};

export const getFridges = async (): Promise<ColdStorageUnit[]> => {
  const req = await axios.get('/fridges/');
  return req.data.results;
};

export const getTunnelTemperatureHistory = async ({
  tunnelId,
  startDate,
  endDate,
}: {
  tunnelId: string;
  startDate: string;
  endDate: string;
}): Promise<TemperatureHistoryResponse> => {
  const params = new URLSearchParams({ startDate, endDate });
  const req = await axios.get(`/tunnels/${tunnelId}/temperature?${params.toString()}`);
  return req.data;
};

export const getTunnelHumidityHistory = async ({
  tunnelId,
  startDate,
  endDate,
}: {
  tunnelId: string;
  startDate: string;
  endDate: string;
}): Promise<HumidityHistoryResponse> => {
  const params = new URLSearchParams({ startDate, endDate });
  const req = await axios.get(`/tunnels/${tunnelId}/humidity?${params.toString()}`);
  return req.data;
};

export const getFridgeTemperatureHistory = async ({
  fridgeId,
  startDate,
  endDate,
}: {
  fridgeId: string;
  startDate: string;
  endDate: string;
}): Promise<TemperatureHistoryResponse> => {
  const params = new URLSearchParams({ startDate, endDate });
  const req = await axios.get(`/fridges/${fridgeId}/temperature?${params.toString()}`);
  return req.data;
};

export const getFridgeHumidityHistory = async ({
  fridgeId,
  startDate,
  endDate,
}: {
  fridgeId: string;
  startDate: string;
  endDate: string;
}): Promise<HumidityHistoryResponse> => {
  const params = new URLSearchParams({ startDate, endDate });
  const req = await axios.get(`/fridges/${fridgeId}/humidity?${params.toString()}`);
  return req.data;
};

export const updateTunnelNotificationSettings = async ({
  tunnelId,
  payload,
}: {
  tunnelId: string;
  payload: NotificationSettingsPayload;
}) => {
  const req = await axios.put(`/tunnels/${tunnelId}/notification`, payload);
  return req.data;
};

export const updateFridgeNotificationSettings = async ({
  fridgeId,
  payload,
}: {
  fridgeId: string;
  payload: NotificationSettingsPayload;
}) => {
  const req = await axios.put(`/fridges/${fridgeId}/notification`, payload);
  return req.data;
};
